import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

const apps = [
  { href: 'https://eligibl.org', label: 'eligibl.org', shot: '/screenshots/eligibl.png' },
  { href: 'https://wallet-king.app', label: 'wallet-king.app', shot: '/screenshots/wallet-king.png' },
  { href: 'https://calderacompliance.com', label: 'calderacompliance.com', shot: '/screenshots/caldera.png' },
];

const divisions = [
  {
    title: 'Fullstack Application Development',
    description:
      'We design, build, and run the applications. These three are in production.',
    shots: apps,
    link: '/products',
    linkLabel: 'Learn More',
    apps,
  },
  {
    title: 'Research Lab',
    description:
      'Publishing technical work, experimenting with ideas, and building credibility through papers, open source, prototypes, and engineering breakdowns.',
    image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800&q=80',
    link: '/research',
    linkLabel: 'Learn More',
    focuses: ['AI Automation Systems', 'Agent Workflows', 'Developer Productivity', 'Local AI Infrastructure'],
  },
  {
    title: 'Security Engineering Workforce',
    description:
      'A growing team of cybersecurity professionals. They do high-quality work across frameworks, including the SOC 2 controls behind ComplianceOS: production access, encryption, and how fast vulnerabilities get patched.',
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80',
    link: '/security',
    linkLabel: 'Request a quote',
    focuses: ['SOC 2', 'Access control', 'Encryption', 'Vulnerability response'],
  },
  {
    title: 'Working with subsidies',
    description:
      'Eligibl screens people for federal and state aid. The plan is to help them finish the application and actually receive the subsidy.',
    image: '/screenshots/eligibl.png',
    link: '/#subsidies',
    linkLabel: 'How Eligibl works',
    focuses: ['Food', 'Housing', 'Healthcare', 'Cash assistance'],
  },
];

export default function Divisions() {
  return (
    <section className="divisions" id="work">
      {divisions.map((div, index) => (
        <div className={`division-card ${div.shots ? 'shots-row' : index % 2 === 0 ? 'img-left' : 'img-right'}`} key={div.title}>
          {div.shots ? (
            <div className="division-shots">
              {div.shots.map((shot) => (
                <a key={shot.href} href={shot.href} target="_blank" rel="noreferrer">
                  <img src={shot.shot} alt={`${shot.label} screenshot`} />
                  <span>{shot.label}</span>
                </a>
              ))}
            </div>
          ) : (
            <div className="division-image">
              <img src={div.image} alt="" loading="lazy" />
            </div>
          )}
          <div className="division-content">
            <h2>{div.title}</h2>
            <p>{div.description}</p>
            <ul className="division-focuses">
              {div.apps
                ? div.apps.map((app) => (
                    <li key={app.href}>
                      <a href={app.href} target="_blank" rel="noreferrer">{app.label}</a>
                    </li>
                  ))
                : div.focuses.map((focus) => <li key={focus}>{focus}</li>)}
            </ul>
            {div.link.startsWith('http') ? (
              <a href={div.link} className="learn-more">{div.linkLabel} <FiArrowRight /></a>
            ) : (
              <Link to={div.link} className="learn-more">{div.linkLabel} <FiArrowRight /></Link>
            )}
          </div>
        </div>
      ))}
    </section>
  );
}
